import React from "react";
import { Link, useNavigate } from "react-router-dom";

import CustomButton from "Components/Commons/CustomButton/CustomButton";


import HeaderMobileLogoImg from "../../Assets/Images/LandingPage/mobile_header_logo.svg";
import ClassLinkLogo from "../../Assets/Images/Footer/classlink-logo_blue.png";
import { ReactComponent as FacebookIcon } from "../../Assets/Images/Header/Facebook.svg";
import { ReactComponent as InstaIcon } from "../../Assets/Images/Header/Instagram.svg";
import { ReactComponent as TiktokIcon } from "../../Assets/Images/Header/TikTok.svg";
import { SOCIAL_MEDIA_LINKS } from "Helpers";
import { FooterContainer } from "./Footer.style";

const Footer = (props) => {
	const navigate = useNavigate();

	const handleRequestDemo = () => {
		navigate("/contact-us");
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	const handleSubjectClick = (id) => {
		navigate(`/subjects#${id}`);
		setTimeout(() => {
			const el = document.getElementById(id);
			if (el) {
				el.scrollIntoView({ behavior: "smooth" });
			}
		}, 100);
	};

	const handleNav = (path) => {
		navigate(path);
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	const handleSubscriptionLinkClick = (plan) => {
		navigate("/subscription", { state: { plan } });
		window.scrollTo({ top: 0, behavior: "smooth" });
	}

	return (
		<FooterContainer className="mains_footer">
			<footer>
				<div className="footer-wrappers">
					{/* Call to Action Section */}
					{!props?.isCTAHidden && (
						<div className="footers_cta">
							<div className="mygrid-container">
								<div className="mygrid-row">
									<div className="mygrid-col-xl-8 mygrid-col-lg-12 footers_cta_desc">
										<h3>
											Request Your <span className="redfont">Free Demo Today</span>
										</h3>
										<h4 className="redfont">Ready to experience the power of game-based learning?</h4>
										<p>Request a live demo and discover how easy it is to create custom study guide, engage students across subjects, and track learning in real time.</p>
										<p>Whether you are a teacher, parent, or school leader, we will show you exactly how Subjects Master can work for you.</p>
									</div>
									<div className="mygrid-col-xl-4 mygrid-col-lg-12 footers_cta_btn">
										<CustomButton onClick={handleRequestDemo} text="Request a Demo" />
									</div>
								</div>
							</div>
						</div>
					)
					}

					<div className="footer-bottom-main">
						{/* Footer Bottom Section */}
						<div className="footer_bottom">
							<div className="mygrid-container">
								<div className="mygrid-row footer_cols">
									{/* Logo & About */}
									<div className="mygrid-col-lg-4 mygrid-col-md-12 mygrid-col-sm-12  footer_cols-in footer_logo_col">
										<Link to="/"><img src={props?.logoSrc || HeaderMobileLogoImg} alt="subjects-master" className="footer-logo" /></Link>
										<p>Empowering teachers and motivating students through fun, incentivized learning that boosts retention and test scores</p>
										<h5 className="social_media_title">Social Media</h5>
										<div className="footer-social">
											<ul>
												<li>
													<a href={SOCIAL_MEDIA_LINKS.FACEBOOK} aria-label="Facebook">
														<FacebookIcon />
													</a>
												</li>
												<li>
													<a href={SOCIAL_MEDIA_LINKS.INSTAGRAM} aria-label="Instagram">
														<InstaIcon />
													</a>
												</li>
												<li>
													<a href={SOCIAL_MEDIA_LINKS.TIKTOK} aria-label="TikTok">
														<TiktokIcon />
													</a>
												</li>
											</ul>
										</div>
									</div>

									<div className="mygrid-col-lg-2 mygrid-col-md-3 mygrid-col-sm-4 mygrid-col-xs-12 footer_cols-in">
										<h4>Sitemap</h4>
										<ul>
											<li>
												<span onClick={() => handleNav("/")}>Home</span>
											</li>
											<li>
												<span onClick={() => handleNav("/about-us")}>About Us</span>
											</li>
											<li>
												<span onClick={() => handleNav("/testimonials")}>Testimonials</span>
											</li>
											<li>
												<span onClick={() => handleNav("/contact-us")}>Contact Us</span>
											</li>
										</ul>
									</div>

									{/* Sitemap */}
									<div className="mygrid-col-lg-2 mygrid-col-md-3 mygrid-col-sm-4 mygrid-col-xs-12 footer_cols-in">
										<h4>Subjects</h4>
										<ul>
											<li>
												<span onClick={() => handleSubjectClick("civics")}>Civics</span>
											</li>
											<li>
												<span onClick={() => handleSubjectClick("science")}>Science</span>
											</li>
											<li>
												<span onClick={() => handleSubjectClick("math")}>Math</span>
											</li>
											<li>
												<span onClick={() => handleSubjectClick("foreign-language")}>Foreign Language</span>
											</li>
											<li>
												<span onClick={() => handleSubjectClick("english")}>English</span>
											</li>
											<li>
												<span onClick={() => handleSubjectClick("history")}>History</span>
											</li>
											<li>
												<span onClick={() => handleSubjectClick("economics")}>Economics</span>
											</li>
										</ul>
									</div>

									{/* Subscription Plans */}
									<div className="mygrid-col-lg-2 mygrid-col-md-3 mygrid-col-sm-4 mygrid-col-xs-12 footer_cols-in">
										<h4>Subscription Plans</h4>
										<ul>
											<li onClick={() => handleSubscriptionLinkClick("basic")}><span>Basic Plan</span></li>
											<li onClick={() => handleSubscriptionLinkClick("premium")}><span>Premium Plan</span></li>
											<li onClick={() => handleSubscriptionLinkClick("professional")}><span>Professional Plan</span></li>
										</ul>
									</div>

									{/* Useful Links */}
									<div className="mygrid-col-lg-2 mygrid-col-md-3 mygrid-col-sm-4 mygrid-col-xs-12 footer_cols-in">
										<h4>Useful Links</h4>
										<ul>
											<li><span onClick={() => handleNav("/data-security")}>Data Security</span></li>
											<li><span onClick={() => handleNav("/privacy-policy")}>Privacy Policy</span></li>
											<li><span onClick={() => handleNav("/terms-and-conditions")}>Terms & Conditions</span></li>
										</ul>
									</div>
								</div>
							</div>
						</div>

						{/* Copyright */}
						<div className="copyright_footer">
							<div className="mygrid-container">
								<div className="mygrid-row">
									<div className="mygrid-col-md-6 copyright_txt_col">
										<div className="copyright_txt">
											&copy; 2025 <Link to="/">Subjects Master LLC.</Link> All rights reserved.
										</div>
									</div>
									<div className="mygrid-col-md-6 credit_txt_col">
										<div className="credit_txt">
											Partnered by <a href="https://www.classlink.com/" rel="noreferrer" target="_blank" title="ClassLink"><img src={ClassLinkLogo} alt="ClassLink Logo" />
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</FooterContainer>
	);
};

export default Footer;
